import React from 'react';
import SurveyRow from "./SurveyRow";
import SurveyCard from "./SurveyCard";
import ErrorBoundary from "../../../meta/ErrorBoundary";

function SurveysList(props) {

    const { surveys, completedCountMap, displayType } = props;

    function generateSurveysTable(surveys) {
        let surveysRowsHtml = surveys.map((survey, index) => {
            const numRespondents = completedCountMap[survey.questId] ?? 0;
            return (
                <ErrorBoundary boundaryName="Survey Row Component" key={"table_item_survey_key_" + survey.questId + "_index_" + index}>
                    <SurveyRow history={props.history} survey={survey} numberOfRespondents={numRespondents}/>
                </ErrorBoundary>
            )
        });

        return (
            <div className="surveys__list surveys__list--table">
                <div className="surveys__list__table">
                    <div className="surveys__list__table__header">
                        <div className="surveys__list__table__header__col">Status</div>
                        <div className="surveys__list__table__header__col">Survey title</div>
                        <div className="surveys__list__table__header__col">Respondents</div>
                        <div className="surveys__list__table__header__col">Created</div>
                        <div className="surveys__list__table__header__col">Modified</div>
                        <div className="surveys__list__table__header__col">Action</div>
                    </div>
                    {surveysRowsHtml}
                </div>
            </div>
        )
    }

    function generateSurveysCards(surveys) {
        let surveysCardsHtml = surveys.map((survey, index) => {
            const numRespondents = completedCountMap[survey.questId] ?? 0;
            return (
                <ErrorBoundary boundaryName="Survey Card Component" key={"card_item_survey_key_" + survey.questId + "_index_" + index}>
                    <SurveyCard history={props.history} survey={survey} numberOfRespondents={numRespondents}/>
                </ErrorBoundary>
            )
        });

        return (
            <div className="surveys__list surveys__list--cards">
                { surveysCardsHtml }
            </div>
        );
    }

    return (
        displayType === "table" ? generateSurveysTable(surveys) : generateSurveysCards(surveys)
    );
}

export default SurveysList;